// src/components/sections/ProductsServicesSection.js
import React from 'react';
import ServiceCard from '../ServiceCard'; // Import the card component

function ProductsServicesSection({ data }) {
  // Destructure with default values to prevent errors if data is missing
  const { datasets = {}, saas = {}, consulting = {} } = data || {};

  return (
    <section id="products-services" className="py-20 bg-gray-50 scroll-mt-16">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16">Our Products & Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
          {/* Pass data for each card type */}
          {datasets.icon && <ServiceCard {...datasets} />}
          {saas.icon && <ServiceCard {...saas} />}
          {consulting.icon && <ServiceCard {...consulting}/>}
        </div>
      </div>
    </section>
  );
}

export default ProductsServicesSection;
